import { FormGroup } from "reactstrap";
import CustomDropDown from "../../../Common/FormFields/CustomDropDown";
import InSeason from "./InSeason";
import OffSeason from "./OffSeason";
import Other from "./Other";
import { useDispatch, useSelector } from "react-redux";
import { addVideoScheduleInformation } from "../../../Redux/Actions/VideoScheduleAction";
const UploadVideoForm = ({ formik }) => {
  const dispatch = useDispatch();
  const videoScheduleInformation = useSelector(
    (state) => state?.videoScheduleInformation
  );
  const options = [
    {
      id: 1,
      name: "In-Season",
    },
    {
      id: 2,
      name: "Off-Season",
    },
    {
      id: 3,
      name: "Other",
    },
  ];

  return (
    <>
      <FormGroup>
        <label className="fmlabel mt-6 semi-bold">
          Event <span className="redstar">*</span>
        </label>
        <CustomDropDown
          selected={videoScheduleInformation?.uploadvideoEvent}
          setSelected={(value) =>
            addVideoScheduleInformation(dispatch, {
              fieldName: "uploadvideoEvent",
              value: value,
            })
          }
          formik={formik}
          fieldName="uploadvideoEvent"
          defaultSelectOption="Select Event Type"
          options={options}
          fieldToShow="name"
          optionValue="name"
        />
      </FormGroup>
      {videoScheduleInformation?.uploadvideoEvent === "In-Season" && (
        <InSeason formik={formik} />
      )}
      {videoScheduleInformation?.uploadvideoEvent === "Off-Season" && (
        <OffSeason formik={formik} />
      )}
      {videoScheduleInformation?.uploadvideoEvent === "Other" && (
        <Other formik={formik} />
      )}
    </>
  );
};

export default UploadVideoForm;
